import React, { memo } from 'react';
import t from '../../../core/staticData/translation';
import useTranslation from '../../../core/customHooks/useTranslation';
import WonBackground from '../../../images/popup-won-background.png';
import { getUserWinningInfo } from '../../../state-management/accessors/usersAccessors';
import { connect } from 'react-redux';
import { cntrlGetUserWinningInfo, cntrlPostUserWinningInfo } from '../../../state-management/actions/usersActions';
import { PRIZE_TYPES } from '../../../core/constants/constants';

const WinPopup = ({ setModalState, userWinningInfo, updateUserWinningInfo,  }) => {
  const translate = useTranslation();

  const handleClosePopup = () => {
    setModalState('');
    updateUserWinningInfo({roundsId: [userWinningInfo[0].roundId] })
  };

  return (
    <div style={{
      backgroundImage: `url(${WonBackground}), linear-gradient(rgba(55, 27, 94, 1), rgba(71, 38, 120, 1), rgba(113, 67, 195, 1))`,
      border: '1px solid rgba(164, 105, 255, 1)'
    }} className="wrapper-popup-won">
      <div className="popup-won-header">
        <div className="popup-won-header-title">
          { translate(t.CONGRATULATIONS) }
        </div>
      </div>
      <span className="popup-won-reward">{ translate(t.REWARD_WON) }</span>
      <span className="popup-won-count">{userWinningInfo[0]?.winAmount }</span>
      <span className="popup-won-type">{translate(PRIZE_TYPES[userWinningInfo[0]?.moneyType]) }</span>
      <span className="popup-won-round">{userWinningInfo[0]?.roundName }</span>
      <button type='button' className="popup-won-btn" onClick={handleClosePopup}>OK</button>
    </div>
  );
};
const mapStateToProps = state => ({
  userWinningInfo: getUserWinningInfo(state)
});

const mapDispatchToProps = dispatch => ({
  updateUserWinningInfo: (payload) => dispatch(cntrlPostUserWinningInfo(payload)),
  getUserWinningInfo: () => dispatch(cntrlGetUserWinningInfo()),
});
export default connect(mapStateToProps, mapDispatchToProps)(memo(WinPopup));

